module.exports = __webpack_public_path__ + "static/img/sternstunde-logo.7f558bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sternstunde-logo.png
// module id = /KWk
// module chunks = 1